import { Injectable } from '@angular/core';
import { AlternativeCertification } from 'src/app/recruiting/candidates/submittal/models/submittal-job-qualification-requirement.model';

export interface HasAlternativeCertifications {
    availableAlternativesByJobId?: Record<number, AlternativeCertification[]>;
}

@Injectable({ providedIn: 'root' })
export class AlternativeCertificationsService {
    shouldShowAlternativeCertifications(item: HasAlternativeCertifications, jobId?: number): boolean {
        return this.getAlternativesForJob(item, jobId).length > 0;
    }

    getAlternativesToDisplay(item: HasAlternativeCertifications, jobId?: number): AlternativeCertification[] {
        const alternatives = this.getAlternativesForJob(item, jobId);
        if (!alternatives.length) {
            return [];
        }

        const metAlternatives = alternatives.filter((alt) => alt.isMet);
        return metAlternatives.length > 0 ? metAlternatives : alternatives;
    }

    getAlternativesDisplayText(item: HasAlternativeCertifications, jobId?: number): string {
        const alternatives = this.getAlternativesToDisplay(item, jobId);
        if (!alternatives.length) {
            return '';
        }
        return `(alts: ${alternatives.map((alt) => alt.name).join(', ')})`;
    }

    private getAlternativesForJob(item: HasAlternativeCertifications, jobId?: number): AlternativeCertification[] {
        const alternativesByJobId = item.availableAlternativesByJobId;
        if (!alternativesByJobId) {
            return [];
        }

        if (jobId !== undefined && jobId !== null) {
            return alternativesByJobId[jobId] ?? [];
        }

        const jobIds = Object.keys(alternativesByJobId);
        if (jobIds.length === 1) {
            return alternativesByJobId[Number(jobIds[0])] ?? [];
        }

        return [];
    }
}
